/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // // Debounced scroll listeners.  Up and down only fire on direction changes
  // // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

gsap.registerPlugin(ScrollTrigger);

let panels = gsap.utils.toArray(".panel");
// // we'll create a ScrollTrigger for each panel just to track when each panel's top hits the top of the viewport (we only need this for snapping)
// let tops = panels.map(panel => ScrollTrigger.create({trigger: panel, start: "top top"}));

panels.forEach((panel, i) => {
  ScrollTrigger.create({
    trigger: panel,
    start: () => panel.offsetHeight < window.innerHeight ? "top top" : "bottom bottom", // if it's shorter than the viewport, we prefer to pin it at the top
    pin: true, 
    pinSpacing: false,
    toggleClass: { targets: panels[i], className: "slide-active" }
  });
});

// ScrollTrigger.create({
  //snap: {
//    snapTo: (progress, self) => {
//      let panelStarts = tops.map(st => st.start), // an Array of all the starting scroll positions. We do this on each scroll to make sure it's totally responsive. Starting positions may change when the user resizes the viewport
//          snapScroll = gsap.utils.snap(panelStarts, self.scroll()); // find the closest one
//      return gsap.utils.normalize(0, ScrollTrigger.maxScroll(window), snapScroll); // snapping requires a progress value, so convert the scroll position into a normalized progress value between 0 and 1
//    },
//    duration: 0.5
//  }
//});

  
  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // DY added this code
  let loading = false;

  window.addEventListener('scroll', () => {
      const pagination = document.querySelector('#pagination');
      if (!pagination) return;

      const nextUrl = pagination.dataset.nextUrl;
      if (!nextUrl || loading) return;

      const scrollY = window.scrollY + window.innerHeight;
      const offset = pagination.offsetTop;

      if (scrollY >= offset - 200) {
          loading = true;

          fetch(nextUrl)
              .then(response => response.text())
              .then((data) => {
                  const parser = new DOMParser();
                  const htmlDoc = parser.parseFromString(data, 'text/html');
                  const newProducts = htmlDoc.querySelectorAll('#product-grid .product-grid-item'); // update class if needed
                  const grid = document.querySelector('#product-grid');

                  newProducts.forEach(item => grid.appendChild(item));

                  const newPagination = htmlDoc.querySelector('#pagination');
                  if (newPagination) {
                      pagination.dataset.nextUrl = newPagination.dataset.nextUrl;
                  } else {
                      pagination.remove();
                  }

                  loading = false;
              });
        }
    });
})();

// AJAX filter handler — replaces full-page reload when clicking silhouette/color tiles
(function() {
  let filterLoading = false;

  function applyFilterUrl(url) {
    if (filterLoading) return;
    filterLoading = true;

    document.body.classList.add('is-filter-loading');

    fetch(url)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(data, 'text/html');

        // 1. Replace product grid contents
        const newGrid = htmlDoc.querySelector('#product-grid');
        const currentGrid = document.querySelector('#product-grid');
        if (newGrid && currentGrid) {
          currentGrid.innerHTML = newGrid.innerHTML;
        }

        // 2. Update pagination (so lazy load keeps working)
        const newPagination = htmlDoc.querySelector('#pagination');
        const currentPagination = document.querySelector('#pagination');
        if (newPagination && currentPagination) {
          currentPagination.dataset.nextUrl = newPagination.dataset.nextUrl;
        } else if (newPagination && !currentPagination) {
          document.querySelector('.collection__products')?.appendChild(newPagination);
        } else if (!newPagination && currentPagination) {
          currentPagination.remove();
        }

        // 3. Update active filter chips (e.g. "Totes ×")
        const newActive = htmlDoc.querySelector('.collection__active__filters');
        const currentActive = document.querySelector('.collection__active__filters');
        if (newActive && currentActive) {
          currentActive.innerHTML = newActive.innerHTML;
        }

        // 4. Re-render silhouette + color bars (so active states update)
        ['.silhouette-bar', '.color-bar'].forEach(sel => {
          const newBar = htmlDoc.querySelector(sel);
          const currentBar = document.querySelector(sel);
          if (newBar && currentBar) {
            currentBar.innerHTML = newBar.innerHTML;
          }
        });

        // 5. Push the new URL so back button works and URL is shareable
        history.pushState({ url }, '', url);

        // 6. Scroll up to where the bars are so user sees the filter result
        document.querySelector('[data-filter-bar]')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      })
      .catch(err => {
        // On failure, fall back to a real navigation
        console.error('Filter fetch failed:', err);
        window.location.href = url;
      })
      .finally(() => {
        document.body.classList.remove('is-filter-loading');
        filterLoading = false;
      });
  }

  // Browser back/forward — only handle entries we created via pushState,
  // not native navigation between full page loads (which has e.state === null)
  window.addEventListener('popstate', (e) => {
    if (e.state && e.state.url) {
      applyFilterUrl(window.location.pathname + window.location.search);
    }
  });

  // Expose the click handler so inline onclick="handleFilterClick(event, this)"
  // on filter links can call it. Each filter link explicitly opts in via markup;
  // no implicit document-wide click watching.
  window.handleFilterClick = function(e, link) {
    // Let cmd/ctrl/shift-click open in new tab as normal
    if (e.metaKey || e.ctrlKey || e.shiftKey) return true;
    e.preventDefault();
    const url = link.getAttribute('href');
    if (url) applyFilterUrl(url);
    return false;
  };
})();
